import dynamic from 'next/dynamic'
import cn from '#/utils/classnames'

const FoldingCube = dynamic(() => import('./Spinners/FoldingCube'), { ssr: false })
const Circle = dynamic(() => import('./Spinners/Circle'), { ssr: false })
const Hexagon = dynamic(() => import('./Spinners/Hexagon'), { ssr: false })

interface OverlaySpinnerProps {
  bgInvisible?: boolean
  visible: boolean
  size: number
  color: string
  text?: React.ReactNode
  type: 'folding-cube' | 'circle' | 'hexagon'
  absolute: boolean
}

export default function OverlaySpinner({
  bgInvisible,
  visible,
  size,
  color,
  text,
  absolute,
  type
}: OverlaySpinnerProps) {
  return (
    <div
      className={cn(
        'fixed inset-0 bg-white bg-opacity-80 flex flex-col justify-center items-center transition-opacity duration-500 opacity-100 z-50 visible',
        { 'hidden opacity-0 invisible': !visible },
        { 'bg-opacity-0': bgInvisible },
        { absolute }
      )}
    >
      <div>
        {type === 'folding-cube' && <FoldingCube color={color} size={size} />}
        {type === 'circle' && <Circle color={color} size={size} />}
        {type === 'hexagon' && <Hexagon color={color} size={size} />}
      </div>
      <div className='mt-1' style={{ color }}>
        {text}
      </div>
    </div>
  )
}

OverlaySpinner.defaultProps = {
  size: 64,
  color: '#6651f5',
  text: '',
  absolute: false,
  type: 'hexagon',
  visible: false
}
